import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Scale, Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { consumeOAuthToken } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        const hash = location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const token = params.get('token');

        if (!token) {
          console.error('No token in callback fragment');
          navigate('/login?oauth_error=no_token', { replace: true });
          return;
        }

        await consumeOAuthToken(token);

        // Clear the hash and navigate to dashboard
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login?oauth_error=callback_failed', { replace: true });
      }
    };

    processCallback();
  }, [location.hash, consumeOAuthToken, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-6">
        <div className="flex items-center justify-center gap-3">
          <div className="w-12 h-12 bg-navy rounded-sm flex items-center justify-center">
            <Scale className="w-6 h-6 text-white" />
          </div>
          <span className="text-3xl font-serif font-bold text-navy">ERP Legal</span>
        </div>
        <div className="flex items-center justify-center gap-3">
          <Loader2 className="w-5 h-5 animate-spin text-bronze" />
          <span className="text-muted-foreground">Completing sign in...</span>
        </div>
      </div>
    </div>
  );
}
